// extracted by mini-css-extract-plugin
module.exports = {"container":"style_container__S31Je","avatar":"style_avatar__S3UkD","introduction":"style_introduction__Y6bvv","date":"style_date__Evu3G","name":"style_name__2MHuc"};